/* Welcome offer: when to open, sign-up through Shopify's customer form, reveal + apply the code. */
(() => {
  const d = document.getElementById('ubWelcome');
  if (!d || window !== window.top || location.pathname.startsWith('/challenge')) return;
  const form = document.getElementById('wpForm');
  const pill = document.querySelector('[data-wp-open]');
  const code = d.dataset.code;
  const DAY = 864e5, SNOOZE = 14 * DAY;
  const get = k => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const put = (k, v) => { try { v == null ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch (e) {} };
  const sget = k => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  const sput = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} };
  const phone = () => matchMedia('(max-width: 699px)').matches;
  const q = new URLSearchParams(location.search);
  const force = q.get('welcome') === '1';
  let shown = false;

  // A footer sign-up counts too.
  if (document.querySelector('#footerNews .ok')) put('ub-news', '1');

  function open() {
    if (d.open) return;
    shown = true;
    if (pill) pill.hidden = true;
    if (phone()) d.show(); else d.showModal();
    sput('ub-wp-seen', '1');
    if (!d.classList.contains('done')) setTimeout(() => { if (!phone()) form && form.querySelector('input[type=email]').focus({ preventScroll: true }); }, 350);
  }
  function close() {
    if (!d.open) return;
    d.close();
  }
  d.addEventListener('close', () => {
    if (d.classList.contains('sending') || d.classList.contains('done')) return;
    put('ub-wp-snooze', String(Date.now() + SNOOZE));
    sput('ub-wp-pill', '1');
    if (pill) pill.hidden = false;
  });
  d.addEventListener('keydown', e => { if (e.key === 'Escape' && !d.matches(':modal')) { e.preventDefault(); close(); } });
  d.addEventListener('click', e => {
    if (e.target.closest('[data-wp-close]')) { close(); return; }
    if (e.target === d) { const r = d.querySelector('.wp-card').getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close(); }
  });
  if (pill) pill.addEventListener('click', open);

  // Reveal: flip the ticket, show the code, a burst of gold.
  function burst() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const host = d.querySelector('[data-wp-burst]'), t = d.querySelector('.wp-ticket');
    const sky = d.querySelector('.wp-sky').getBoundingClientRect(), tr = t.getBoundingClientRect();
    host.style.left = (tr.left - sky.left + tr.width / 2) + 'px';
    host.style.top = (tr.top - sky.top + tr.height / 2) + 'px';
    const cols = ['#F6C453', '#FFE7A3', '#FFFFFF', '#F2A65A', '#9FD3EA'];
    for (let i = 0; i < 34; i++) {
      const s = document.createElement('i'), a = Math.random() * Math.PI * 2, dist = 70 + Math.random() * 150;
      if (i % 3 === 0) s.className = 'st';
      s.style.setProperty('--x', Math.cos(a) * dist + 'px');
      s.style.setProperty('--y', Math.sin(a) * dist + 'px');
      s.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
      s.style.setProperty('--s', (i % 3 === 0 ? 12 + Math.random() * 8 : 5 + Math.random() * 6) + 'px');
      s.style.setProperty('--c', cols[i % cols.length]);
      s.style.animationDelay = (Math.random() * .25) + 's';
      host.appendChild(s);
    }
    setTimeout(() => { host.innerHTML = ''; }, 1600);
  }
  function success(real = true) {
    if (real) { put('ub-news', '1'); put('ub-wp-snooze', null); }
    if (pill) pill.hidden = true;
    d.classList.add('done');
    d.querySelector('[data-wp-step="ask"]').hidden = true;
    d.querySelector('[data-wp-step="done"]').hidden = false;
    d.querySelector('[data-wp-tk]').textContent = code;
    setTimeout(burst, 380);
    setTimeout(() => d.querySelector('[data-wp-done-h]').focus({ preventScroll: true }), 60);
    if (!real) return;
    // Put the code on the visitor's cart session so checkout picks it up.
    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'follow' })
      .then(r => { if (r.ok) d.querySelector('[data-wp-applied]').hidden = false; }).catch(() => {});
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('welcome_signup', { code }); } catch (e) {}
  }

  const copyBtn = d.querySelector('[data-wp-copy]');
  if (copyBtn) copyBtn.addEventListener('click', () => {
    const done = () => { copyBtn.classList.add('ok'); copyBtn.querySelector('span').textContent = 'Copied'; };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  // Sign-up uses Shopify's normal form flow, exactly like the footer form: its invisible hCaptcha
  // runs on the real submit event, then the page posts and comes back (sometimes via Shopify's
  // "Challenge" page). We remember the sign-up and reopen the pop-up with the code on return.
  if (form) form.addEventListener('submit', e => {
    const err = d.querySelector('[data-wp-err]'), btn = form.querySelector('.wp-go'), email = form.querySelector('input[type=email]');
    const stop = () => { e.preventDefault(); e.stopImmediatePropagation(); };
    err.hidden = true;
    if (form.querySelector('.wp-hp input').value) return stop();
    if (!email.checkValidity()) { stop(); err.textContent = 'Please enter a valid email address.'; err.hidden = false; email.focus(); return; }
    const picks = [...form.querySelectorAll('.wp-chip input:checked')].map(i => i.value);
    form.querySelector('[data-wp-tags]').value = ['newsletter', 'welcome-popup'].concat(picks).join(',');
    put('ub-wp-pending', String(Date.now()));
    btn.setAttribute('aria-busy', 'true');
    btn.querySelector('span').textContent = 'Unlocking…';
    // A visible hCaptcha puzzle must be able to sit above the pop-up: leave modal mode.
    d.classList.add('sending');
    if (d.matches(':modal')) { d.close(); d.show(); }
    setTimeout(() => { if (btn.getAttribute('aria-busy')) { btn.removeAttribute('aria-busy'); btn.querySelector('span').textContent = 'Try again'; } }, 25000);
  });

  // Back from a human check.
  if (+get('ub-wp-pending') > Date.now() - 15 * 60e3 && (q.get('customer_posted') === 'true' || document.querySelector('#footerNews .ok'))) {
    put('ub-wp-pending', null);
    try { q.delete('customer_posted'); history.replaceState(history.state, '', location.pathname + (q.toString() ? '?' + q : '')); } catch (x) {}
    setTimeout(() => { open(); success(); }, 400);
    return;
  }
  if (q.get('welcome') === 'done') { setTimeout(() => { open(); success(false); }, 500); return; }
  if (force) { put('ub-news', null); put('ub-wp-snooze', null); setTimeout(open, 500); return; }
  if (get('ub-news') === '1') return;
  if (+get('ub-wp-snooze') > Date.now()) { if (sget('ub-wp-pill') && pill) pill.hidden = false; return; }

  // When to open: ~40% down the page, ~20s of attention, or (desktop) heading for the tab bar.
  const busy = () => document.querySelector('dialog[open]:not(#ubWelcome), .drawer:not([hidden]), .mega:not([hidden]), .ta:not([hidden])') ||
    (document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName));
  const born = Date.now();
  function tryOpen() {
    if (shown) return;
    if (busy()) { setTimeout(tryOpen, 4000); return; }
    cleanup(); open();
  }
  const onScroll = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    if (max > 0 && scrollY / max > .4 && Date.now() - born > 4000) tryOpen();
  };
  const onLeave = e => { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - born > 5000) tryOpen(); };
  let left = 20000, last = Date.now(), timer;
  const tick = () => { if (document.hidden) { last = Date.now(); return; } left -= Date.now() - last; last = Date.now(); if (left <= 0) tryOpen(); };
  timer = setInterval(tick, 1000);
  document.addEventListener('visibilitychange', () => { last = Date.now(); });
  addEventListener('scroll', onScroll, { passive: true });
  if (!phone()) document.documentElement.addEventListener('mouseout', onLeave);
  function cleanup() {
    clearInterval(timer);
    removeEventListener('scroll', onScroll);
    document.documentElement.removeEventListener('mouseout', onLeave);
  }
})();
